import { useLocation } from "@tanstack/react-router";

import { settingsNavPathV3 } from "../helpers/urlHelpers";
import { useMediaQuery, useTailwindMdScreenMediaQuery } from "./useMediaQuery";

export const usePlanPageVariant = () => {
  const { pathname } = useLocation();
  const isMdScreenOrLarger = useTailwindMdScreenMediaQuery();
  const isNarrowDesktop = useMediaQuery("(max-width: 1200px)");

  // Mobile screens (< 768px)
  const isMobileLayout = !isMdScreenOrLarger;

  // Desktop and tablet screens (>= 768px)
  const isDesktopLayout = isMdScreenOrLarger;

  // Compact layout for medium-width screens (768px - 1200px)
  const isCompactLayout = isDesktopLayout && isNarrowDesktop;

  const isPlansPageLayout = [
    settingsNavPathV3.plans.general,
    settingsNavPathV3.plans.billing,
    settingsNavPathV3.plans.invoices,
    settingsNavPathV3.plans.payment_details,
  ].some(path => pathname === path);

  return {
    isPlansPageLayout, // Full-width layout without sidebar
    isMobileLayout, // Mobile screens (< 768px)
    isDesktopLayout, // Desktop/tablet screens (>= 768px)
    isCompactLayout, // Narrower desktop layout (768px - 1200px)
  };
};
